import { max, min } from 'lodash';
import { ActionType } from '../infrastructure/actionTypes';
import { IEditorState, IPage, ISpread } from '../infrastructure/interfaces';
import { mapPagesToSpreads, movePages } from '../services/PageService';

const editor = (state: IEditorState = {
  selectedPage: null,
  selectedSpread: null,
  isSaved: true,
  zoomLevel: 100
}, action: any): IEditorState => {

  switch (action.type) {
    case ActionType.DRAG_N_DROP_PRODUCT:
      {
        const { index, model, spread } = action.data;
        const spreadLeftPlaceholders = spread.left ? spread.left.placeholders : [];
        const spreadRightPlaceholders = spread.right ? spread.right.placeholders : [];
        const placeholders = [
          ...spreadLeftPlaceholders,
          ...spreadRightPlaceholders,
        ];
        placeholders[index].data = model.data;
        placeholders[index].type = model.type;

        let newPage;
        const leftPage = { ...spread.left, placeholders: placeholders.splice(0, spreadLeftPlaceholders.length) };
        const rightPage = spread.right ? { ...spread.right, placeholders: [...placeholders] } : null;
        const newSpread = {
          id: spread.id,
          left: leftPage,
          right: rightPage,
        };

        if (index < spreadLeftPlaceholders.length) {
          newPage = newSpread.left;
        } else {
          newPage = newSpread.right;
        }
        return {
          ...state,
          selectedSpread: newSpread,
          selectedPage: newPage,
          isSaved: false,
        };
      }
    case ActionType.REMOVE_PRODUCT:
      {
        const { index, spread } = action.data;
        const spreadLeftPlaceholders = spread.left.placeholders;
        const spreadRightPlaceholders = spread.right ? spread.right.placeholders : [];
        const placeholders = [
          ...spreadLeftPlaceholders,
          ...spreadRightPlaceholders,
        ];
        placeholders[index].data = null;
        placeholders[index].type = null;

        let newPage;
        const leftPage = { ...spread.left, placeholders: placeholders.splice(0, spreadLeftPlaceholders.length) };
        const rightPage = spread.right ? { ...spread.right, placeholders: [...placeholders] } : null;
        const newSpread = {
          id: spread.id,
          left: leftPage,
          right: rightPage,
        };

        if (index < spreadLeftPlaceholders.length) {
          newPage = newSpread.left;
        } else {
          newPage = newSpread.right;
        }

        return {
          ...state,
          selectedSpread: newSpread,
          selectedPage: newPage,
          isSaved: false,
        };
      }
    case ActionType.ON_SPREAD_SELECT_PAGE_RESULT:
      {
        const { spread } = action;
        return {
          ...state,
          selectedSpread: spread,
        };
      }
    case ActionType.ON_PAGE_SELECT_PAGE_RESULT:
      {
        const { page } = action;
        return {
          ...state,
          selectedPage: page,
        };
      }
    case ActionType.ON_PAGE_OR_SPREAD_SELECT:
      {
        const { data, document } = action;

        let newSelectedSpread;
        let newSelectedPage;

        if (data.left) {
          newSelectedSpread = data;
          newSelectedPage = data.left;
        } else {
          newSelectedPage = data;
          document.spreads.map((spread: any) => {
            if (spread.left.number === data.number || spread.right && spread.right.number === data.number) {
              newSelectedSpread = {
                id: spread.id,
                left: spread.left,
                right: spread.right,
              };
            } else if (spread.left.number === data.number - 1) {
              newSelectedSpread = {
                id: spread.id,
                left: spread.left,
                right: null,
              };
            }
          });
        }
        return {
          ...state,
          selectedSpread: newSelectedSpread,
          selectedPage: newSelectedPage,
        };
      }
    case ActionType.ON_ADD_PAGE_OR_SPREAD:
      {
        let newState = { ...state };
        const editor = action.editor;

        let spreadIndex = 0;
        let newSelectedPage = null;
        let newSelectedSpread = null;
        if (editor.selectedSpread.right) {
          if (editor.selectedSpread.right.type === 2) {
            spreadIndex = action.document.spreads.findIndex((s: any) => s.id === editor.selectedSpread.id);
          }
        } else if (editor.selectedSpread.left) {
          if (editor.selectedSpread.left.type === 2) {
            spreadIndex = action.document.spreads.findIndex((s: any) => s.id === editor.selectedSpread.id);
          }
        }

        newSelectedSpread = action.document.spreads[spreadIndex + 1] || action.document.spreads[spreadIndex];
        newSelectedPage = newSelectedSpread.left;

        newState = {
          ...state,
          selectedPage: newSelectedPage,
          selectedSpread: newSelectedSpread,
          isSaved: false,
        };
        return newState;
      }
    case ActionType.ON_REMOVE_PAGE:
      {
        let newState = { ...state };
        const { pageId, allPages } = action;
        const currentPage = state.selectedPage;
        const currentPageNumber = (currentPage != null) ? currentPage.number : 0;
        const prevPage = pageId === currentPageNumber
          ? allPages.filter((page: IPage) => { return page.number === pageId - 1; })[0]
          : currentPage;
        newState = {
          ...state,
          selectedPage: prevPage,
          isSaved: false,
        };
        return newState;
      }
    case ActionType.ON_REMOVE_PAGE_RESWITCH_EDITOR:
      {
        let newState = { ...state };
        const { pageId, newSpreads, allPages } = action;

        const currentSpread = state.selectedSpread;
        const currentSpreadID = ((currentSpread != null) && (currentSpread.id != undefined)) ? currentSpread.id : 0;
        const currentPage = state.selectedPage;
        const currentPageNumber = (currentPage != null) ? currentPage.number : 0;

        const prevPage = pageId === currentPageNumber
          ? allPages.filter((page: IPage) => { return page.number === pageId - 1; })[0]
          : currentPage;

        let prevSpread = pageId === currentPageNumber
          ? prevPage.position === 'right'
            ? newSpreads.filter((spread: ISpread) => { return spread.id === currentSpreadID; })[0]
            : newSpreads.filter((spread: ISpread) => { return spread.id === currentSpreadID - 1; })[0]
          : newSpreads.filter((spread: ISpread) => { return spread.id === currentSpreadID; })[0];
        if (!prevSpread) {
          prevSpread = newSpreads[newSpreads.length - 1];
        }
        if (prevPage.type === 0 || prevPage.type === 1) {
          prevSpread = newSpreads[0];
        }
        newState = {
          ...state,
          selectedPage: prevPage,
          selectedSpread: prevSpread,
          isSaved: false,
        };
        return newState;
      }
    case ActionType.ON_REMOVE_SPREAD:
      {
        let newState = { ...state };
        const { spreadId, allSpreads } = action;

        const currentSpread = state.selectedSpread;
        const currentSpreadID = ((currentSpread != null) && (currentSpread.id != undefined)) ? currentSpread.id : 0;
        const currentPage = state.selectedPage;

        let prevSpread;
        if (spreadId === currentSpreadID) {
          prevSpread = allSpreads.filter((spread: ISpread) => { return spread.id === spreadId - 1; })[0];
        } else if (spreadId < currentSpreadID) {
          prevSpread = allSpreads.filter((spread: ISpread) => { return spread.id === spreadId; })[0];
        } else {
          prevSpread = currentSpread;
        }
        const prevPage = spreadId === currentSpreadID
          ? prevSpread.left
          : currentPage;
        newState = {
          ...state,
          selectedPage: prevPage,
          selectedSpread: prevSpread,
          isSaved: false,
        };
        return newState;
      }
    case ActionType.CHANGE_ZOOM:
      {
        const type = action.payload;
        const zoomStepSize = 10;
        const minZoom = 25;
        const currentZoom = state.zoomLevel;
        var newZoom = 100;
        switch (type) {
          case 'minus':
            newZoom = max<number>([minZoom, (currentZoom - zoomStepSize)])!;
            break;
          case 'plus':
            newZoom = min<number>([100, currentZoom + zoomStepSize])!;
            break;
          case 'reset':
            newZoom = 100;
            break;
        }
        return {
          ...state,
          zoomLevel: newZoom
        };
      }
    case ActionType.VALIDATE_PAGES_COUNT_VALUE: {
      return state;
    }
    case ActionType.MOVE_CROP:
      {
        return {
          ...state,
          isSaved: false,
        };
      }
    case ActionType.OPEN_DOCUMENT_DONE:
      {
        return {
          ...state,
          isSaved: false,
          selectedPage: (action.document.pages != undefined) ? action.document.pages[0] : null,
          selectedSpread: (action.document.spreads != undefined) ? action.document.spreads[0] : null,
        };
      }
    case ActionType.CREATE_DOCUMENT:
      {
        return {
          ...state,
          selectedPage: null,
          selectedSpread: null,
        };
      }
    case ActionType.SAVE_DOCUMENT_DONE:
      return { ...state, isSaved: true };
    case ActionType.MOVE_THUMBNAIL:
      {
        const {
          dragIndex,
          hoverIndex,
          document,
        } = action;

        const docType = document.type;
        const pages = movePages(document.pages, dragIndex, hoverIndex, action.editor);
        const spreads = mapPagesToSpreads(pages, docType);

        const selectedSpreadID = (state.selectedSpread != null) ? state.selectedSpread.id : -1;
        const selectedSpreadNumber = ((state.selectedPage != null) && (state.selectedPage.number != null)) ? state.selectedPage.number : -1;
        const selectedSpread = spreads.find(s => s.id === selectedSpreadID);
        const selectedPage = pages.find(p => p.number === selectedSpreadNumber);
        return {
          ...state,
          selectedSpread: (selectedSpread != undefined) ? selectedSpread : null,
          selectedPage: (selectedPage != undefined) ? selectedPage : null,
          isSaved: false,
        };
      }
    case ActionType.ON_MOVE_PLACEHOLDERS:
      {
        const { dragInfo, spread } = action.data;
        const { dragIndex, dropIndex } = dragInfo;

        const spreadLeftPlaceholders = spread.left.placeholders;
        const spreadRightPlaceholders = spread.right ? spread.right.placeholders : [];

        const placeholders = [
          ...spreadLeftPlaceholders,
          ...spreadRightPlaceholders,
        ];

        const oldDrag = placeholders[dragIndex];
        const oldDrop = placeholders[dropIndex];

        oldDrop.data = null;
        oldDrop.type = null;

        placeholders[dragIndex] = oldDrop;
        placeholders[dropIndex] = oldDrag;

        let newPage;
        const leftPage = { ...spread.left, placeholders: placeholders.splice(0, spreadLeftPlaceholders.length) };
        const rightPage = spread.right ? { ...spread.right, placeholders: [...placeholders] } : null;
        const newSpread = {
          id: spread.id,
          left: leftPage,
          right: rightPage,
        };

        if (dragIndex < spreadLeftPlaceholders.length) {
          newPage = newSpread.left;
        } else {
          newPage = newSpread.right;
        }
        return {
          ...state,
          selectedSpread: newSpread,
          selectedPage: newPage,
          isSaved: false,
        };
      }
    default:
      return state;
  }
};

export default editor;



// WEBPACK FOOTER //
// ./src/reducers/editor.ts